export { BASchoolModel } from './BASchoolModel';
export { BASportDetailModel } from './BASchoolModel';